var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { class: _vm.offline ? "offline" : "online" },
    [
      _c(
        "v-main",
        [
          _c("v-container", { attrs: { fluid: "" } }, [
            _c("div", [
              _c(
                "div",
                { staticClass: "status" },
                [
                  _vm.offline
                    ? _c("v-icon", { staticClass: "status-icon" }, [
                        _vm._v("mdi-wifi-off")
                      ])
                    : _vm._e(),
                  _vm.offline
                    ? _c("v-icon", { staticClass: "status-icon" }, [
                        _vm._v("mdi-signal-off")
                      ])
                    : _vm._e(),
                  !_vm.offline
                    ? _c("v-icon", { staticClass: "status-icon" }, [
                        _vm._v("mdi-wifi")
                      ])
                    : _vm._e(),
                  !_vm.offline
                    ? _c("v-icon", { staticClass: "status-icon" }, [
                        _vm._v("mdi-signal")
                      ])
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "bark" },
                [
                  _vm.offline
                    ? _c(
                        "v-icon",
                        { staticClass: "icon", attrs: { color: "black" } },
                        [_vm._v("mdi-cloud-off-outline")]
                      )
                    : _vm._e(),
                  !_vm.offline
                    ? _c(
                        "v-icon",
                        {
                          staticClass: "icon",
                          attrs: { color: "blue darken-2" }
                        },
                        [_vm._v("mdi-cloud-outline")]
                      )
                    : _vm._e(),
                  _c("br"),
                  _vm.offline
                    ? _c("span", [_vm._v("You are currently Offline")])
                    : _vm._e(),
                  !_vm.offline
                    ? _c("span", [_vm._v("We are back Online!")])
                    : _vm._e(),
                  _c("br"),
                  _c("br"),
                  _c("br"),
                  _c("br"),
                  _vm.offline
                    ? _c("span", [
                        _vm._v("We'll keep checking your internet connection")
                      ])
                    : _vm._e(),
                  !_vm.offline
                    ? _c("span", [_vm._v("Taking you back to the Portal")])
                    : _vm._e(),
                  _c("br"),
                  _vm.offline
                    ? _c("span", [_vm._v("Click below to check now")])
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "check-internet" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        text: "",
                        disabled: _vm.checking || !_vm.offline,
                        ripple: true
                      },
                      on: {
                        click: function($event) {
                          return _vm.check()
                        }
                      }
                    },
                    [
                      _vm.checking && _vm.offline
                        ? _c(
                            "v-icon",
                            { attrs: { color: "white", "x-large": "" } },
                            [_vm._v("mdi-timer-sand")]
                          )
                        : _vm._e(),
                      !_vm.checking && _vm.offline
                        ? _c(
                            "v-icon",
                            { attrs: { color: "white", "x-large": "" } },
                            [_vm._v("mdi-refresh")]
                          )
                        : _vm._e(),
                      !_vm.offline
                        ? _c(
                            "v-icon",
                            { attrs: { color: "white", "x-large": "" } },
                            [_vm._v("mdi-check")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }